// extracted by mini-css-extract-plugin
export default {"textWrapper":"webpack-components-PrivacyAndPermissions-EmailPermissions-module__textWrapper","wrapper":"webpack-components-PrivacyAndPermissions-EmailPermissions-module__wrapper"};